import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';
import { CommonService } from '../../../services/common.service';
import { LangService } from 'src/app/core/services/lang.service';
import { GridService } from 'src/app/shared/services/grid.service';

@Component({
  selector: 'app-parent-list',
  templateUrl: './../../../templates/forms/modals/ledger-list.component.html',
})
export class LedgerListComponent implements OnInit {
  @Input()
  ACC_NO: any;
  
  @Input()
  modalShow: boolean = true;
  
  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  dataObj:any;
  parentList:any[] = [];
  searchFields:any[] = ['ACC_NAME','ACC_NO'];

  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "LedgerListGrid"

  public searchString;
  constructor(private dataService: CommonService,
    public langService: LangService,
    public gridService:GridService) { 
      this.colObj = [
        { headerName: langService.langData.accName, field: 'ACC_NAME', sortable: true, resizable: true, hide: false },
      ];
    }
 

  ngOnInit() {
    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
  }
  onGridReady(grid) {
    this.grid = grid;
    this.gridService.sizeColumnsToFit(grid, this.gridId);

    this.dataService.getLedger()
    .subscribe(arg => {this.parentList = arg.body});
  }
  itemClick(_item) {
    this.modalShow = false;
    this.dataObj = _item;
    this.submit.next();
  }

}
